import { render, staticRenderFns } from "./ShopTransactionTab.vue?vue&type=template&id=0242a146&"
import script from "./ShopTransactionTab.vue?vue&type=script&lang=js&"
export * from "./ShopTransactionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports